import { assoc, omit, set, update } from 'lodash/fp';

import { DESTROY_NOTIFICATION, SPAWN_NOTIFICATION } from './actions';
import { SEVERITY_ERROR, SEVERITY_SUCCESS, SEVERITY_WARNING } from './constants';
import { CLEAR_STORE } from '../shared/actions';

const severityType = [SEVERITY_ERROR, SEVERITY_SUCCESS, SEVERITY_WARNING];

const initialState = {};

function moduleReducer(
	state = {
		spawnedNotifications: initialState,
	},
	action
) {
	switch (action.type) {
		case SPAWN_NOTIFICATION:
			console.assert(
				severityType.includes(action.payload.severity),
				'Unsupported notification severity setting'
			);
			return assoc(['spawnedNotifications', action.payload.id], action.payload, state);
		case DESTROY_NOTIFICATION:
			return action.payload.ids
				? update('spawnedNotifications', omit(action.payload.ids), state)
				: set('spawnedNotifications', [], state);
		case CLEAR_STORE:
			return {
				...state,
				spawnedNotifications: initialState,
			};
		default:
			return state;
	}
}

export default moduleReducer;
